import { cn } from '@/lib/utils';

interface LogoProps {
  size?: number;
  variant?: 'mark' | 'wordmark';
  className?: string;
}

export function Logo({ size = 28, variant = 'wordmark', className }: LogoProps) {
  if (variant === 'mark') {
    return (
      <img
        src="/boss-mark.png"
        alt="BOSS"
        width={size}
        height={size}
        className={cn('block select-none', className)}
        style={{ height: size, width: 'auto' }}
      />
    );
  }

  return (
    <div className={cn('inline-flex items-center gap-2.5 select-none', className)}>
      <img
        src="/boss-mark.png"
        alt=""
        aria-hidden
        className="block"
        style={{ height: size, width: 'auto' }}
      />
      <span
        className="text-foreground"
        style={{
          fontSize: `${size * 0.72}px`,
          fontWeight: 700,
          letterSpacing: '-0.01em',
          lineHeight: 1,
        }}
      >
        BOSS
      </span>
    </div>
  );
}
